export enum UserType {
    ADMIN = 'admin', USER = 'user',
}

export enum DataMode {
    DETAILS, EDIT
}

export enum EditMode {
    NEW, EDIT
}

export enum UserStatus {ACTIVE = 'active', INVITED = 'invited', DELETED = 'deleted', REGISTERED = 'registered'}

export enum DocumentType {
    NEWSLETTER = 'NEWSLETTER', DOCUMENT = 'DOCUMENT', VACANCY = 'VACANCY', LEAVE_FORM = 'LEAVE_FORM'
}

export enum Language {NL = 'NL', EN = 'EN'}

export enum ContentMode {LIVE = 'LIVE', PREVIEW = 'PREVIEW'}